import VectorSource from "ol/source/Vector";
import VectorLayer from "ol/layer/Vector";
import {Icon, Style} from "ol/style";
import GeoJSON from "ol/format/GeoJSON";
import LayerGroup from "ol/layer/Group";
import {Collection} from "ol";


export default class Image360 {
    constructor(axios, folderId=null, setImage360Visible) {
        this.axios = axios;
        this.image360s = null;
        this.image360Layer = [];
        this.image360MapLayer = new LayerGroup({
            id: 'theta_image360',
            title: 'THETAパノラマ',
            layers: [],
        });
        this.featureStyleFunction = (feature, resolution) => {
            return new Style({
                image: new Icon({
                    anchor: [0.5, 0.5],
                    anchorXUnits: 'fraction',
                    anchorYUnits: 'fraction',
                    src: require('@/assets/images/eye-circle-outline.png'),
                    scale: resolution < 0.125 ? 0.05 / resolution : 0.4,
                }),
            });
        };
        if (folderId){
            this.updateImage360Layer(folderId);
        }
        this.openImage360 = false;
        this.image360LayerVisible = false;
        this.setImage360Visible = setImage360Visible;
        this.image360 = {
            image360Id: null,
            feature: null,
            image360Layer: null,
            markerFeature: null,
        }
    }

    setClickEvent(map){
        map.on('click', (evt) => {
            const pixel = map.getEventPixel(evt.originalEvent);
            const hit = map.hasFeatureAtPixel(pixel);
            if (hit){
                const feature = map.forEachFeatureAtPixel(pixel, (feature) => {
                    return feature;
                }, {
                    layerFilter: (layer) => {
                        if (layer.get('image360Id')){
                            this.image360.image360Layer = layer;
                            return true;
                        }
                        return false;
                    }
                });
                if (feature){
                    this.image360.feature = feature;
                    this.openImage360 = true;
                }
            }
        });
    }

    updateImage360Layer(folderId) {
        const layers = [];
        this.image360Layer = [];
        this.axios.get('/api/image360/' + folderId).then((response) => {
            this.image360s = response.data;
            this.image360s.forEach((image360) => {
                this.image360Layer.push({text: JSON.parse(image360.folder_property).shooting_date, value: image360.id, visible: false});
                this.image360LayerVisible = false;
                this.setImage360Visible(this.image360LayerVisible);
                const features = [];
                JSON.parse(image360.property).list.forEach((file) => {
                    features.push({
                        type: "Feature",
                        properties: {
                            url: file.url,
                            width: file.file_width,
                        },
                        id: file.file_name,
                        geometry: {
                            type: "Point",
                            coordinates: file.coordinates,
                        },
                    });
                });
                layers.push(new VectorLayer({
                    image360Id: image360.id,
                    zIndex: 8,
                    title: JSON.parse(image360.folder_property).shooting_date,
                    opacity: 100,
                    visible: false,
                    source: new VectorSource({
                        features: new GeoJSON().readFeatures({
                            type: "FeatureCollection",
                            features: features,
                        }),
                    }),
                    style: this.featureStyleFunction,
                }));
            });
            this.image360MapLayer.setLayers(new Collection(layers));
        });
    }

    getLayerById(id, layer){
        const array = layer.getLayers().getArray();
        for (const layer of array){
            if (layer.get('image360Id') === id){
                return layer;
            }
            else if (layer instanceof LayerGroup){
                const a = this.getLayerById(id, layer);
                if (a) return a;
            }
        }
        return null;
    }

    setVisible(visible, id=null){
        if (id){
            const layer = this.getLayerById(id, this.image360MapLayer);
            layer.setVisible(visible);
            this.image360LayerVisible  = false;
            this.image360Layer.forEach((layer) => {
                this.image360LayerVisible  = this.image360LayerVisible || layer.visible;
            });
            this.image360MapLayer.setVisible(this.image360LayerVisible);
            this.setImage360Visible(this.image360LayerVisible);
        }
        else {
            this.image360MapLayer.setVisible(visible);
            let i = 0;
            this.image360MapLayer.getLayers().getArray().forEach((layer) => {
                if (visible){
                    if (i === 0){
                        layer.setVisible(visible);
                    }
                    i++;
                }
                else {
                    layer.setVisible(visible);
                }
            });
            i = 0;
            this.image360Layer.forEach((layer) => {
                if (visible){
                    if (i === 0){
                        layer.visible = visible;
                    }
                    i++;
                }
                else {
                    layer.visible = visible;
                }
            });
        }
    }

    resetLayers(){
        this.setVisible(false);
        this.image360LayerVisible = false;
        this.setImage360Visible(this.image360LayerVisible);
    }
}
